import React from 'react';
import { PlayCircleIcon } from '@heroicons/react/24/solid'; // Or any play icon you prefer

const WhyDealersChooseUs = () => {
  return (
    <section className=""> {/* Light background for contrast */}
      <div className="container mx-auto px-4 py-16 md:py-24">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Why More Than 1075 Dealers Use LiveFunnel
          </h2>
          <p className="text-lg md:text-xl text-gray-100 opacity-90 leading-relaxed">
            Your website, VDP and ads are choking your lead conversions. These old solutions are slow and not built for today&apos;s Smart Phone mobile-first universe of customers. More than 98% of car buyers are cruising through social media on their phones. When your website or funnel system doesn&apos;t fit their expectations they drop-out. You lose. LiveFunnel dynamic mobile funnels are created for this new reality. Don&apos;t get left behind. Go personalized mobile-first, fast loading interactive funnels that match your car buyers in your market.
          </p>
        </div>

        {/* Video Placeholder */}
        <div className="max-w-3xl mx-auto">
          <div className="custom-aspect-video bg-gray-700 rounded-xl shadow-2xl relative overflow-hidden group border-4 border-video-frame-green">
            {/* Static visual placeholder for the "Old TV" effect and content */}
            <div className="absolute inset-0 flex flex-col items-center justify-center p-8 bg-lime-400">
              <img 
                src="/images/livefunnel-app-screenshot-dynamic.png" // Replace with an actual representative screenshot
                alt="LiveFunnel App Dynamic Screenshot" 
                className="w-full h-auto object-contain rounded-md opacity-80 group-hover:opacity-100 transition-opacity duration-300"
              />
              <div className="absolute inset-0 bg-black bg-opacity-30 group-hover:bg-opacity-10 transition-all duration-300"></div>
              <PlayCircleIcon className="absolute w-20 h-20 md:w-28 md:h-28 text-white opacity-70 group-hover:opacity-90 group-hover:scale-110 transform transition-all duration-300" />

            </div>
            {/* You could add some subtle "scan lines" or "static" overlay for the old TV effect if desired, e.g. using pseudo-elements or an SVG overlay */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyDealersChooseUs;
